// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2LQ-4","flag":"index_flag_66Wty","menuIcon":"index_menuIcon_TV0Ox"};